'use client';

import { AtomicResultsSection as AtomicResultsSectionListing } from '@components/Listing/AtomicResultsSection';
import { AtomicCategoryFacetSection } from '@components/Search/AtomicCategoryFacetSection';
import { AtomicPaginationSection } from '@components/Search/AtomicPaginationSection';
import { AtomicQueryRefinement } from '@components/Search/AtomicQueryRefinement';
import { AtomicResultsSection as AtomicResultsSectionSearch } from '@components/Search/AtomicResultsSection';
import { AtomicStatusSection } from '@components/Search/AtomicStatusSection';
import { SearchResultsBanner } from '@components/Search/SearchResultsBanner';
import { SearchTitle } from '@components/Search/SearchTitle';
import { AtomicSearchContext } from '@contexts/coveo/AtomicSearchContext';
import {
  AtomicLayoutSection,
  AtomicNoResults,
  AtomicQueryError,
  AtomicSearchLayout,
} from '@coveo/atomic-react';
import { MicrocopyFragment } from '@graphql/generated-contentful/graphql';
import { Tag } from '@lib/types/common/Tag';
import { SearchResultsBanner as SearchResultsBannerType } from '@lib/types/search/SearchResultsBanner';
import { AtomicSearchInterfaceWrapper } from './AtomicSearchInterfaceWrapper';
export const SearchPageContent = ({
  isListingPage,
  mappedSearchResultsBanners,
  mappedProductTags,
  paginationMicrocopy,
}: {
  isListingPage: boolean;
  mappedSearchResultsBanners: SearchResultsBannerType[];
  mappedProductTags: Tag[] | undefined;
  paginationMicrocopy: MicrocopyFragment[];
}) => {
  const AtomicResultsSection = isListingPage
    ? AtomicResultsSectionListing
    : AtomicResultsSectionSearch;

  return (
    <div className="lg-container min-h-[25rem] pb-10 pt-4 lg:pb-16 lg:pt-12">
      <AtomicSearchInterfaceWrapper
        id="atomic-search-interface_search"
        shouldExecuteFirstSearch={true}
        reflectStateInUrl={true}
        context={AtomicSearchContext}
      >
        <style>
          {`
            atomic-search-layout {
                grid-template-columns: repeat(12, minmax(0, 1fr)) !important;
                column-gap: 1rem !important;
            }
            atomic-layout-section[section='facets'] {
                grid-column: 1 / span 3 !important;
            }
        
            atomic-layout-section[section='main'] {
                grid-column: 1 / span 12 !important;
            }
        
             @media (min-width: 1024px) {
                atomic-layout-section[section='main'] {
                    grid-column: 4 / span 9 !important;
                }
                
                atomic-search-layout atomic-layout-section[section="facets"] {
                    display: block;
                }
            }

            atomic-no-results::part(icon), atomic-query-error::part(icon) {
                display: none;
            }

            atomic-query-error::part(title) {
                margin-top: unset;
            }

            @media (min-width: 768px) {
                atomic-query-error::part(title) {
                    margin-top: -3rem;
                }
                atomic-no-results::part(no-results) {
                    margin-top: -2rem;
                }
            }

            @media (min-width: 1024px) {
                atomic-query-error::part(title) {
                    margin-top: -2rem;
                }
                atomic-no-results::part(no-results) {
                    margin-top: unset;
                }
            }
            `}
        </style>
        <SearchResultsBanner
          context={AtomicSearchContext}
          banners={mappedSearchResultsBanners}
        />
        <SearchTitle context={AtomicSearchContext} />
        <AtomicSearchLayout>
          <AtomicLayoutSection section="facets">
            <AtomicCategoryFacetSection />
          </AtomicLayoutSection>
          <AtomicLayoutSection section="main">
            <div className="mb-6">
              <AtomicQueryRefinement context={AtomicSearchContext} />
            </div>
            <AtomicStatusSection />
            <AtomicResultsSection
              productTags={mappedProductTags}
              context={AtomicSearchContext}
            />
            <AtomicPaginationSection
              paginationMicrocopySet={paginationMicrocopy}
              context={AtomicSearchContext}
            />
          </AtomicLayoutSection>
        </AtomicSearchLayout>
        <AtomicQueryError />
        <AtomicNoResults />
      </AtomicSearchInterfaceWrapper>
    </div>
  );
};
